import React from 'react';
import { inject, observer } from 'mobx-react';
import { Field, renderField, renderToggle } from '../../../../utils/formFieldHelper';
import Form from '../../../Settings/Form/Form';
import Section from '../../../Section/Section';
import { StoresEnum } from '../../../../stores';

const AutoPollForm = ({ channelStore: { channel, readOnly, updateChannel } }) => {
  const renderFields = () => (
    <>
      <Field name="autoPolls.siteSection" type="text" component={renderField} label="Target or path domain" readOnly={readOnly} allowEmpty />
      <Field name="autoPolls.enabled" type="checkbox" component={renderToggle} label="Add Auto-Create Poll" readOnly={readOnly} />
      <Field name="autoPolls.viewsThreshold" type="number" component={renderField} label="Auto Creation Threshold" readOnly={readOnly} />
    </>
  );

  return (
    <Section title="INSTANT AUTO POLL">
      <Form
        initialValues={channel}
        fields={renderFields()}
        onSubmit={updateChannel}
        hideCancelButton
        hideApproveButton={readOnly}
      />
    </Section>
  );
};

export default inject(StoresEnum.CHANNEL)(observer(AutoPollForm));
